<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Análise de Ofício</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Análise ofício',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <!-- <div class="button-group">
                        <v-btn
                            v-if="$check(user, ['officialletter.create', 'officialletter.create.*', 'officialletter.*', '*'])"
                            type="button" color="primary" elevation="0"
                            @click="modalCreateMultipleAnalysis = true">Criar lote de analises
                        </v-btn>

                        <v-btn
                            v-if="$check(user, ['officialletter.create', 'officialletter.create.*', 'officialletter.*', '*'])"
                            id="btnNew" type="button" color="primary" elevation="0"
                            to="/analise-oficio/novo">Incluir</v-btn>
                    </div> -->
                </div>

            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name"
                                        hide-details outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-text-field dense id="email" label="Email" v-model="dataList.filter.email"
                                        hide-details outlined></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-text-field dense id="registration" label="CPF/CNPJ"
                                        v-model="dataList.filter.registration" hide-details outlined></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>

                                <v-col cols="12" sm="4">
                                    <v-autocomplete dense :items="dataset.clients" label="Caso"
                                        v-model="dataList.filter.client" item-value="id" item-text="name" outlined
                                        hide-details="auto" no-data-text="Nenhum caso encontrado">
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-select dense :items="getFilterCreditorTypes()" label="Classe"
                                        v-model="dataList.filter.type" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>

                                 <v-col cols="12" sm="4">
                                    <v-select dense :items="getAnalysisPhaseTypes()" label="Fase"
                                        v-model="dataList.filter.phase" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>

                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row >
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="table-card-title">
                        Análises
                    
                        <v-spacer></v-spacer>
                        <div v-if="loadingExport" class="mr-10">
                            <v-progress-circular indeterminate color="primary" size="48" width="4"></v-progress-circular>
                        </div>
						<div class="icon-container" @click="loadCsvData()">
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-icon v-on="on" size="x-large">
                                        mdi-microsoft-excel
                                    </v-icon>
                                </template>
                                <span>Exportar dados para CSV</span>
                            </v-tooltip>
                        </div>
                    </v-card-title>	
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhuma análise foi encontrada" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.type`]="{ item }">
                                <v-chip label text-color="primary">
                                    {{
                                        item.userCreditor && item.userCreditor.type ? getTypeName(item.userCreditor.type) : 'N/A'
                                    }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.version`]="{ item }">
                                <v-chip small class="text-uppercase font-weight-bold text-caption" 
                                    label :color="getPhaseChipColor(item.version)" text-color="white">
                                    {{ item.version ? getAnalysisPhaseName(item.version) : 'N/A' }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.client`]="{ item }">
                                {{ item.userCreditor && item.userCreditor.client_id ? getClientName(item.userCreditor.client_id) : 'N/A' }}
                            </template>

                            <template v-slot:[`item.registration`]="{ item }">
                                {{ item.userCreditor && item.userCreditor.registration
                                    ? formatCpfCnpj(item.userCreditor.registration)
                                    : (item.registration
                                        ? formatCpfCnpj(item.registration)
                                        : 'N/A')
                                }}
                            </template>

                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip small class="text-uppercase font-weight-bold text-caption"
                                    :color="getChipColor(item)" label text-color="white">
                                    {{ getChipLabel(item) }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.name`]="{ item }">
                                {{
                                    item.userCreditor && item.userCreditor.name
                                        ? item.userCreditor.name
                                        : (item.name
                                            ? item.name
                                            : 'N/A')
                                }}
                            </template>


                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">
                                    <v-icon
                                        @click="viewItem(item)" size="large" class="me-2">
                                        mdi-pencil-outline
                                    </v-icon>

                                    <!-- <v-icon
                                        :disabled="(!$check(user, ['officialletter.delete', 'officialletter.delete.*', 'officialletter.*', '*']))"
                                        @click="deleteItem(item)" size="large" class="me-2">
                                        mdi-delete
                                    </v-icon> -->
                                </v-row>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash';
import _ from 'lodash';
import axios from 'axios';
import creditorTypes from "@/common/data/creditor-types.data";
import object from "@/common/util/object";
import eventStatus from "@/common/data/event-status.data";
import { cpf, cnpj } from 'cpf-cnpj-validator';

Vue.use(VueLodash)

export default {
    name: "OfficioAnalysisList",

    data: () => ({
        user: null,
        dataset: {
            data: {},
            clients: [],
            creditorTypes: creditorTypes,
            eventStatus: eventStatus,
            analysisPhaseTypes: [{ id: 1, name: "Fase 1" }, { id: 2, name: "Fase 2" }],
        },
        loadingExport: false,
        dataList: {
            filter: {
                name: "",
                email: "",
                client: "",
                type: "",
                registration: "",
                phase: "",
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "CPF/CNPJ", value: "registration" },
                { text: "Caso", value: "client" },
                { text: "Classe", value: "type" },
                { text: "Status", value: "status" },
                { text: "Fase", value: "version" },
                { text: "Criado em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {
        //this.checkPermissions();
        this.load();
        this.loadClients();
    },

    methods: {
        // checkPermissions() {
        //     this.user = this.$root.user.data || this.$root.user;
        //     if (!this.$check(this.user, ['officialletter.get', 'officialletter.get.*', 'officialletter.*', '*'])) this.$router.push(`home`);
        // },

        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load(true);
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        getColorByStatus(status) {
            switch (status) {
                case 0:
                    return 'warning';
                case 1:
                    return 'accent';
                case 2:
                    return 'error';
                case 3:
                    return 'indigo darken-1';
                default:
                    return 'grey';
            }
        },

        formatCpfCnpj(value) {
            return value.length == 14 ? cnpj.format(value) : cpf.format(value);
        },

        getChipColor(item) {
            // if (item.currentReview && item.currentReview.status == 0) {
            //     return "#9FA8DA";
            // }

            if (item.status == 4) {
                return "#7E55AB";
            }

            if (item.status == 5) {
                return "#29B6F6";
            }

            return this.getColorByStatus(item.status);
        },

        getChipLabel(item) {
            // if (item.currentReview && item.currentReview.status == 0) {
            //     return "Em análise";
            // }

            return this.enum(item.status, this.dataset.eventStatus, "id", "name");
        },

        enum(status, eventStatus, idKey, nameKey) {
            const matchedStatus = eventStatus.find((e) => e[idKey] === status);
            return matchedStatus ? matchedStatus[nameKey] : 'Desconhecido';
        },


        getTypeName(typeId) {

            switch (typeId) {
                case 1:
                    return "Classe I - Trabalhista";
                case 2:
                    return "Classe II - Garantia Real";
                case 3:
                    return "Classe III - Quirografários";
                case 4:
                    return "Classe IV - ME/EPP";
                case 5:
                    return "Extraconcursais";
                default:
                    return "N/A";
            }
        },

        getClientName(client_id) {

            if (!client_id) {
                return 'N/A';
            }

            const client = this.dataset.clients.find(s => s.id === client_id);

            if (client && client.name) {
                return client.name.length > 30 ? client.name.slice(0, 30) + '...' : client.name;
            } else {
                return 'N/A';
            }
        },

        getFilterCreditorTypes() {
            return [{ "id": "", "name": "Todos" }, ...this.dataset.creditorTypes]
        },

         getAnalysisPhaseTypes() {
            return [{ "id": "", "name": "Todos" }, ...this.dataset.analysisPhaseTypes]
        },

        async load() {

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            if (search.registration) {
                search.registration = search.registration.replace(/\D/g, '');
            }

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.size;

            try {
                const result = await axios.get('/api/admin/officio-analysis', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async loadClients() {

            try {
                const result = await axios.get(`/api/clients`, { params: { start: 1, limit: 100000, search: {} } });

                const data = result.data.content.data

                data.sort((a, b) => a.name.localeCompare(b.name));

                this.dataset.clients = [{ id: "", name: "Todos " }, ...data];

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },


        viewItem(item) {
            this.$router.push(`analise-oficio/${item.id}`);
        },

        async loadCsvData() {

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja exportar as análises para CSV?',
                title: 'Exportar dados',
                actions: {
                    false: 'Cancelar',
                    true: 'Exportar'
                }
            })

            if (!proceedAction) return;

            try {

                this.loadingExport = true;

                const result = await axios.get('/api/admin/officio-analysis', { params: { limit: 100000000, search: { } } });

                if (result.data.content.data.length == 0) {
                    this.$dialog.notify.error("Sem dados para gerar arquivo CSV!", { position: "top-right", timeout: 2000 });

                    return;
                }

                let newData = [];

                for (let item of result.data.content.data) {

                    let data = {
                        "NR ORDEM": item.id,
                        "CREDOR": item.userCreditor && item.userCreditor.name ? item.userCreditor.name : "N/A",
                        "CPF/CNPJ": item.userCreditor && item.userCreditor.registration ? this.formatCpfCnpj(item.userCreditor.registration) : "N/A",
                        "DEVEDORA": item.userCreditor && item.userCreditor.client_id ? (this.dataset.clients.find(obj => obj.id === item.userCreditor.client_id) || { name: "N/A" }).name : "N/A",
                        "VALOR": item.amount ? parseFloat(item.amount.toString()).toFixed(2) : 'N/A',
                        "ORIGEM CREDITO": item.origin ? item.origin : "N/A",
                        "CLASSE": item.type ? (creditorTypes.find(type => type.id === item.type) || { name: "N/A" }).name : "N/A",
                        "STATUS": (eventStatus.find(status => status.id === item.status) || { name: "N/A" }).name,
                        "MOTIVO": item.reason ? this.cleanHtml(item.reason) : "N/A"
                            
                    };

                    newData.push(data);  

                }

                if (!newData.length) {
                    this.$dialog.notify.warning('Nenhuma informação de análise encontrada!', {
                        position: 'top-right',
                        timeout: 2000
                    })
                    return;
                }

                const header = Object.keys(newData[0]);
                const csvContent = [header.join(';')];

                newData.forEach(item => {
                    const row = header.map(key => {
                        const value = item[key];
                        return typeof value === 'object' && value !== null ? value.join(';') : value;
                    }).join(';');
                    csvContent.push(row);
                });

                const csv = csvContent.join('\r\n');

                const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.setAttribute('href', url);
                link.setAttribute('download', 'Analise de oficio.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.$dialog.notify.info("Arquivo CSV gerado com sucesso!", { position: "top-right", timeout: 2000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.loadingExport = false;
            }

        },

		cleanHtml(html) {
			if (!html) return "";
			
			let text = html.replace(/<[^>]*>/g, "");
			let temp = document.createElement("textarea");
			temp.innerHTML = text;
			return temp.value.trim();
		},

         getAnalysisPhaseName(phaseId) {
            if (phaseId === null || phaseId === undefined || !this.dataset.analysisPhaseTypes) return 'N/A';
            const phase = this.dataset.analysisPhaseTypes.find(p => p.id === phaseId);
            return phase ? phase.name : 'N/A';
        },

        getPhaseChipColor(phaseId) {
            if (phaseId === 1) return '#7E55AB'; // Fase 1 - roxo
            if (phaseId === 2) return '#29B6F6'; // Fase 2 - azul
            return 'grey'; // default
        },

    },
};
</script>

<style lang="scss">
	.icon-container {
		display: flex;
		align-items: center;
		border: 1px solid #ccc;
		padding: 10px;
		border-radius: 8px;
	}

</style>